"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dropdownSelectStyles_1 = require("./dropdownSelectStyles");
var clsx_1 = require("clsx");
var DropdownSelect = function (_a) {
    var formData = _a.formData;
    var _b;
    var styles = dropdownSelectStyles_1.default();
    var _c = formData.options, inputLabel = _c.inputLabel, enumOptions = _c.enumOptions, label = formData.label, id = formData.id, required = formData.required, value = formData.value, onChange = formData.onChange, placeholder = formData.placeholder, formContext = formData.formContext;
    var _d = react_1.useState(enumOptions), enumOptionsList = _d[0], setEnumOptionsList = _d[1];
    react_1.useEffect(function () {
        if (id === 'root_location_dealer' && formContext.availableDealers.length) {
            setEnumOptionsList(formContext.availableDealers);
        }
    }, [formContext.availableDealers]);
    // TODO: find nicer way to fix it XPD-1248
    react_1.useEffect(function () {
        setEnumOptionsList(enumOptions);
    }, [enumOptions]);
    if (id === 'root_housing_housingDistrict') {
        window.addEventListener('root_housing_housingDepartment_change', function () {
            setEnumOptionsList([]);
        });
    }
    var handleChange = function (e) {
        if (id === 'root_housing_housingDepartment') {
            window.dispatchEvent(new Event('root_housing_housingDepartment_change'));
        }
        onChange(e.target.value);
    };
    return (<core_1.Box>
      {inputLabel !== false && (<core_1.Typography variant={'subtitle1'} data-test={"dropdown_select:label:" + id}>
          <core_1.InputLabel className={styles.label} htmlFor={id} required={required}>
            {label}
          </core_1.InputLabel>
        </core_1.Typography>)}
      <core_1.Select id={id} className={clsx_1.default(styles.select, !value && styles.itemDisabled)} disabled={!((_b = enumOptionsList) === null || _b === void 0 ? void 0 : _b.length)} labelId={id} value={value || '-1'} label={label} variant="outlined" data-test={"dropdown_select:" + id} onChange={handleChange} classes={{
        root: styles.root,
        select: styles.select,
        outlined: styles.outlined,
        disabled: styles.disabled,
    }}>
        <core_1.MenuItem value={'-1'} disabled={true} classes={{
        root: styles.itemDisabled,
    }}>
          {(placeholder !== null && placeholder !== void 0 ? placeholder : '')}
        </core_1.MenuItem>
        {enumOptionsList ? (enumOptionsList
        .filter(function (option) { return option.value; })
        .map(function (option, index) {
        var _a, _b, _c;
        return (<core_1.MenuItem key={index} value={(_a = option) === null || _a === void 0 ? void 0 : _a.value} data-test={"enquiry_form:dropdown_select:option:" + ((_b = option) === null || _b === void 0 ? void 0 : _b.label)} classes={{
            root: styles.item,
        }}>
                  {(_c = option) === null || _c === void 0 ? void 0 : _c.label}
                </core_1.MenuItem>);
    })) : (<core_1.MenuItem />)}
      </core_1.Select>
    </core_1.Box>);
};
exports.default = DropdownSelect;
